import React from 'react'
import { useSelector } from 'react-redux'
import { Typography } from '@material-ui/core'

import { SectionBlock } from '../SectionBlock'

import { useStyles } from './DisciplinesSection.style'

const DisciplinesSection = () => {
  const classes = useStyles()

  const { championship } = useSelector((state) => state.championships)

  const { disciplines } = championship

  return (
    <SectionBlock title='Disciplinas' className={classes.container}>
      {disciplines.map((d) => (
        <Typography key={d.id} className={classes.disciplinne} variant='h6'>
          {d.name}
        </Typography>
      ))}
    </SectionBlock>
  )
}

export default DisciplinesSection
